module.exports = __webpack_public_path__ + "media/images/backgrounds/login_bg_lg-abe7d6c33668a92ad134d00154ff6234.png";